export default __webpack_public_path__ + "static/media/team-installation.75f044e4.webp";